"use client";

import { cn } from "@/lib/utils";
import { memo } from "react";
import { enterpriseCard, pricingCards } from "./constants";
import { PricingPlansProps } from "./types";
import { PricingCard } from "@/components/screen/global-components/pricing";

const PricingPlans = ({ className }: PricingPlansProps) => {
  return (
    <div
      className={cn(
        "grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-4 lg:grid-cols-[0.82fr_0.82fr_1fr]",
        className
      )}
    >
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:flex lg:flex-wrap md:col-span-2 lg:rounded-2xl lg:border lg:border-[#C8D4F3] lg:h-[826px] lg:grid lg:grid-cols-2 lg:gap-0">
        {pricingCards.map((card, i) => {
          return (
            <PricingCard
              key={i}
              {...card}
              className={cn(
                {
                  "lg:border-0 lg:border-r-1 lg:rounded-none lg:rounded-tl-2xl lg:rounded-bl-2xl":
                    i === 0,
                },
                {
                  "lg:border-0 lg:rounded-none lg:rounded-tr-2xl lg:rounded-br-2xl":
                    i === 1,
                }
              )}
            />
          );
        })}
      </div>
      <PricingCard
        className="border-[#2F80ED] 
            lg:rounded-2xl md:col-span-2 lg:col-span-1"
        {...enterpriseCard}
      />
    </div>
  );
};

export default memo(PricingPlans);
